// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8b1b71bf","823":"4265f1b4"}[chunkId] + ".chunk.js";
};